import { Invoice } from '../invoice';
import { CreatePaymentTransactionRequest, FileUploadOutput } from '../payment';
import { TripCheckInLocation, TripVisitResponse } from '../trip';

export interface OfflineCurrentCustomerMetadata {
  customerId: string;
  customerName: string;
  phone: string;
}

export enum OfflineTaskType {
  CHECK_IN = 'CHECK_IN',
  CHECK_OUT = 'CHECK_OUT',
  PLACE_ORDER = 'PLACE_ORDER',
  COLLECT_PAYMENT = 'COLLECT_PAYMENT',
}

export interface OfflineCheckOutRequest {
  checkInId?: string;
}

export interface OfflineCollectPaymentRequest {
  data: CreatePaymentTransactionRequest;
  media: FileUploadOutput[];
  selectedInvoices?: Invoice[];
  customerInfo?: {
    customerName: string;
    customerId: string;
  };
  paymentTempId?: string;
}

export interface OfflineTaskPayloadMap {
  [OfflineTaskType.CHECK_IN]: TripCheckInLocation;
  [OfflineTaskType.CHECK_OUT]: OfflineCheckOutRequest;
  [OfflineTaskType.PLACE_ORDER]: {
    itemsSynced?: boolean;
    askForConfirmation?: boolean;
  };
  [OfflineTaskType.COLLECT_PAYMENT]: OfflineCollectPaymentRequest;
}

export interface OfflineTaskResultMap {
  [OfflineTaskType.CHECK_IN]: TripVisitResponse;
  [OfflineTaskType.CHECK_OUT]: void;
  [OfflineTaskType.PLACE_ORDER]: void;
  [OfflineTaskType.COLLECT_PAYMENT]: void;
}

export interface OfflineExecutionContext {
  checkInId?: string;
}

export type PersistedTask<T extends OfflineTaskType = OfflineTaskType> = {
  id: string;
  type: T;
  entityKey?: string;
  payload: OfflineTaskPayloadMap[T];
  customerMetadata?: OfflineCurrentCustomerMetadata;
  retries: number;
  timestamp: number;
};

export interface CustomerDownloadStatus {
  catalog: boolean;
  profile: boolean;
}
